import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3e15d48a")

_pushScopeId("data-v-3e15d48a")
const _hoisted_1 = { class: "toc_ui__infoList_main" }
const _hoisted_2 = { class: "toc_ui_infoList_item_label" }
const _hoisted_3 = { class: "toc_ui_infoList_item_value" }
const _hoisted_4 = {
  key: 0,
  class: "toc_ui_infoList_item_value_txt"
}
const _hoisted_5 = { class: "popover" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "toc_ui_infoList_item_value_txt"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("此里程数仅为检测时表显里程")
const _hoisted_10 = {
  key: 2,
  class: "toc_ui_infoList_item_value_txt"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.state.dataList, (item) => {
        return (_openBlock(), _createBlock("div", {
          class: "toc_ui_infoList_item",
          key: item.name
        }, [
          _createVNode("div", _hoisted_2, _toDisplayString(item.fieldName), 1),
          _createVNode("div", _hoisted_3, [
            (item.fieldValue && item.fieldCode =='carBrandAndSeries')
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _createVNode("span", {
                    class: "moreText",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {$setup.state.popover = true}, ["stop"]))
                  }, _toDisplayString(item.fieldValue), 1),
                  _withDirectives(_createVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createTextVNode(_toDisplayString(item.fieldValue), 1)
                  ], 512), [
                    [_vShow, $setup.state.popover]
                  ])
                ]))
              : (item.fieldValue && item.fieldCode !='carBrandAndSeries')
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _createTextVNode(_toDisplayString(item.fieldValue) + " ", 1),
                    (item.fieldCode === "mileage" || item.fieldCode === "mileageKilometers")
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "qs",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {$setup.state.showTip = true}, ["stop"]))
                        }, [
                          _createVNode("img", {
                            src: require('@/assets/tocV3/question.png')
                          }, null, 8, ["src"]),
                          _withDirectives(_createVNode("span", null, [
                            _hoisted_8,
                            _hoisted_9
                          ], 512), [
                            [_vShow, $setup.state.showTip]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_10, "-"))
          ])
        ]))
      }), 128))
    ]),
    ($setup.state.moreStatus)
      ? (_openBlock(), _createBlock("p", {
          key: 0,
          class: "moreArrow",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.changeListStatus && $setup.changeListStatus(...args)))
        }, [
          _createTextVNode(_toDisplayString($setup.state.showOrHide ? '展开': '收起') + "车辆配置 ", 1),
          ($setup.state.showOrHide)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                class: "arrow",
                src: require('@/assets/toc/arrowDown.png')
              }, null, 8, ["src"]))
            : (_openBlock(), _createBlock("img", {
                key: 1,
                class: "arrow",
                src: require('@/assets/toc/arrowUp.png')
              }, null, 8, ["src"]))
        ]))
      : _createCommentVNode("", true)
  ]))
})